var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "passenger-summary" },
    [
      _c("div", { staticClass: "passenger-summary__field" }, [
        _c("b", { staticClass: "passenger-summary__attribute" }, [
          _vm._v("Title"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "passenger-summary__value" }, [
          _vm._v(_vm._s(_vm.details.title)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "passenger-summary__field" }, [
        _c("b", { staticClass: "passenger-summary__attribute" }, [
          _vm._v("First Name"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "passenger-summary__value" }, [
          _vm._v(_vm._s(_vm.details.firstName)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "passenger-summary__field" }, [
        _c("b", { staticClass: "passenger-summary__attribute" }, [
          _vm._v("Other Names"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "passenger-summary__value" }, [
          _vm._v(_vm._s(_vm.details.otherNames)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "passenger-summary__field" }, [
        _c("b", { staticClass: "passenger-summary__attribute" }, [
          _vm._v("Surname"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "passenger-summary__value" }, [
          _vm._v(_vm._s(_vm.details.lastName)),
        ]),
      ]),
      _vm._v(" "),
      _vm.details.lead
        ? [
            _c("div", { staticClass: "passenger-summary__field" }, [
              _c("b", { staticClass: "passenger-summary__attribute" }, [
                _vm._v("Mobile Phone Number"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "passenger-summary__value" }, [
                _vm._v(_vm._s(_vm.details.mobilePhone)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "passenger-summary__field" }, [
              _c("b", { staticClass: "passenger-summary__attribute" }, [
                _vm._v("Home Phone Number"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "passenger-summary__value" }, [
                _vm._v(_vm._s(_vm.details.homePhone)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "passenger-summary__field" }, [
              _c("b", { staticClass: "passenger-summary__attribute" }, [
                _vm._v("Email Address"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "passenger-summary__value" }, [
                _vm._v(_vm._s(_vm.details.email)),
              ]),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "passenger-summary__field" }, [
        _c("b", { staticClass: "passenger-summary__attribute" }, [
          _vm._v("Date of Birth"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "passenger-summary__value" }, [
          _vm._v(
            _vm._s(_vm.details.dayOfBirth) +
              " " +
              _vm._s(_vm.getMonthName(_vm.details.monthOfBirth)) +
              " " +
              _vm._s(_vm.details.yearOfBirth)
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "passenger-summary__field" }, [
        _c("b", { staticClass: "passenger-summary__attribute" }, [
          _vm._v("Sex (indicated by passport)"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "passenger-summary__value" }, [
          _vm._v(_vm._s(_vm.details.sex)),
        ]),
      ]),
      _vm._v(" "),
      _vm.details.lead
        ? _c("div", { staticClass: "passenger-summary__field" }, [
            _c("b", { staticClass: "passenger-summary__attribute" }, [
              _vm._v("Address"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "passenger-summary__value" },
              [
                _vm._l(_vm.details.address.addressLines, function (line) {
                  return _c("span", { key: line }, [
                    _vm._v("\n        " + _vm._s(line) + "\n        "),
                    _c("br"),
                  ])
                }),
                _vm._v(
                  "\n      " + _vm._s(_vm.details.address.town) + "\n      "
                ),
                _c("br"),
                _vm._v(
                  "\n      " + _vm._s(_vm.details.address.county) + "\n      "
                ),
                _c("br"),
                _vm._v(
                  "\n      " + _vm._s(_vm.details.address.country) + "\n      "
                ),
                _c("br"),
                _vm._v(
                  "\n      " + _vm._s(_vm.details.address.postCode) + "\n    "
                ),
              ],
              2
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.details.visaIds, function (visaRequired, visaId) {
        return [
          _c("div", { key: visaId, staticClass: "passenger-summary__field" }, [
            _c("b", { staticClass: "passenger-summary__attribute" }, [
              _vm._v(_vm._s(_vm.getVisaNameFromCode(visaId))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "passenger-summary__value" }, [
              _vm._v(_vm._s(visaRequired)),
            ]),
          ]),
        ]
      }),
      _vm._v(" "),
      _c("div", { staticClass: "passenger-summary__field" }, [
        _c("b", { staticClass: "passenger-summary__attribute" }, [
          _vm._v("Medical/Mobility Limitations"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "passenger-summary__value" }, [
          _vm._v(
            _vm._s(
              _vm.details.mobilityLimitations
                ? _vm.details.mobilityDetails
                : "None"
            )
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "passenger-summary__field" }, [
        _c("b", { staticClass: "passenger-summary__attribute" }, [
          _vm._v("Dietary Requirements"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "passenger-summary__value" }, [
          _vm._v(
            _vm._s(
              _vm.details.dietaryRequests
                ? _vm.details.dietaryRequirements
                : "None"
            )
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.details.lead
        ? _c("div", { staticClass: "passenger-summary__field" }, [
            _c("b", { staticClass: "passenger-summary__attribute" }, [
              _vm._v("Marketing Communication"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "passenger-summary__value" }, [
              _vm._v("\n      Receive via mail -\n      "),
              _c("b", [
                _vm._v(_vm._s(_vm.details.marketingMail ? "Yes" : "No")),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v("Receive via email -\n      "),
              _c("b", [
                _vm._v(_vm._s(_vm.details.marketingEmail ? "Yes" : "No")),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }